<script lang="ts">
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {getUserOldGamesTransactions} from 'src/components/cabinet/#services/getUserOldGamesTransactions'
    import Time from 'svelte-time'

    export let userId

    let currentPage = 0
    let perPage = 15
    let maxButtons = 5
    let totalCount = 5

    let currencyList = {
        1: 'Points',
        2: 'SOUL',
        3: 'Membership',
        4: 'ETH',
        5: 'LIS'
    }

    let descriptionList = {
        '1': 'Spin debit',
        '2': 'Spin credit',
        '3': 'Survey',
        '4': 'Chest opening',
        '5': 'Deposit from site',
        '6': 'Subscription purchase',
        '7': 'Consumable purchase',
        '8': 'Withdrawal to the site',
        '9': 'Tournament',
        '10': 'Subscription purchase from site',
        '11': 'Upgrade cat',
        '12': 'Mew bonus',
        '13': 'Offline earning multiplication',
        '14': 'Speed boost',
        '15': 'Cat buy',
        '16': 'Credit by admin',
        '17': 'Debit by admin',
        '18': 'Achievement',
        '19': 'Task complete',
        '20': 'Referral task',
        '21': 'Referrer reward',
        '22': 'Offer purchase',
        '23': 'Unkink exchange',
        '24': 'Lootbox reward',
        '25': 'Lootbox purchase',
        '26': 'Withdrawal to the site rollback',
        '27': 'Buy science',
    }

    function getDescription(key) {
        return descriptionList[key] ? descriptionList[key] : key
    }

    $: getUserOldGamesTransactions.send({
        data: {
            userId,
            page: currentPage + 1,
            perPage,
        },
    })
</script>

<div class="transactions-list">
    <Table bordered striped responsive>
        <thead>
        <tr>
            <td class="text-center">Game</td>
            <td class="text-center">Amount</td>
            <td class="text-center">Description</td>
            <td class="text-center">Date</td>
        </tr>
        </thead>
        <tbody>
        {#if $getUserOldGamesTransactions.loading}
            {#each {length:perPage} as item}
                <tr>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                </tr>
            {/each}
        {:else if $getUserOldGamesTransactions.error || !$getUserOldGamesTransactions.hasValue }
            <tr>
                <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
            </tr>
        {:else}
            {#each $getUserOldGamesTransactions.value.data as { amount, is_credit, reason, created_at, app_id }}
                <tr>
                    <td>{#if app_id === 3}Cats{:else if app_id}Dragons{/if}</td>
                    <td class="nobr notranslate">
                        {#if !is_credit}
                            <span class="text-danger">-{Math.round((+amount + Number.EPSILON) * 10000) / 10000}</span>
                        {:else}
                            <span class="text-success">+{Math.round((+amount + Number.EPSILON) * 10000) / 10000}</span>
                        {/if}
                    </td>
                    <td>{#if descriptionList[reason]}{descriptionList[reason]}{:else}{reason}{/if}</td>
                    <td class="text-center"><Time relative timestamp={created_at}/></td>
                </tr>
            {:else}
                <tr>
                    <td class="text-center" colspan="4">No items</td>
                </tr>
            {/each}
        {/if}
        </tbody>
    </Table>
    {#if $getUserOldGamesTransactions.hasValue}
        <Pagination
            bind:currentPage={currentPage}
            totalCount={$getUserOldGamesTransactions.value.totalCount}
            {perPage}
            {maxButtons}
            disabled={$getUserOldGamesTransactions.loading || $getUserOldGamesTransactions.loading}
        />
    {/if}
</div>

<style>
    .transactions-list :global(table) {
        width: auto;
    }

    .transactions-list :global(td) {
        vertical-align: middle;
        padding: 12px 25px;
        line-height: normal;
    }

    .transactions-list :global(nav .pagination) {
        justify-content: flex-start;
    }
</style>
